const form = {
  formId: "edit-user-form",
  formField: {
    firstName: {
      name: "firstName",
      label: "First Name",
      type: "text",
      errorMsg: "First name is required.",
    },
    lastName: {
      name: "lastName",
      label: "Last Name",
      type: "text",
      errorMsg: "Last name is required.",
    },
    phone: {
      name: "phone",
      label: "Phone Number",
      type: "tel",
      errorMsg: "Phone number is required.",
    },
    email: {
      name: "email",
      label: "Email Address",
      type: "email",
      errorMsg: "Email address is required.",
      invalidMsg: "Your email address is invalid",
    },
    type: {
      name: "type",
      label: "Type",
      type: "text",
    },
  },
};

export default form;
